import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
const base = import.meta.env.BASE_URL;
// Existing shared hash URLs continue to open the equivalent crawlable page.
const legacyRoute = window.location.hash.startsWith('#/');
if (legacyRoute) {
 const legacy = window.location.hash.slice(2);
 window.history.replaceState(null, '', `${base}${legacy}${window.location.search}`);
}
const root = document.getElementById('root');
if (!root) throw new Error('Root element missing');
const app = <StrictMode><BrowserRouter basename={base}><App /></BrowserRouter></StrictMode>;
if (root.hasChildNodes() && !legacyRoute && document.querySelector('meta[name="robots"]')?.getAttribute('content') !== 'noindex,follow') hydrateRoot(root, app); else createRoot(root).render(app);
